export enum TranslationTableActions {
  DELETE = 'DELETE',
  RESTART = 'RESTART',
  GET_PROJECT = 'GET_PROJECT',
  DOWNLOAD_SOURCE = 'DOWNLOAD_SOURCE',
  DOWNLOAD_TARGET = 'DOWNLOAD_TARGET',
}
